import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: {
	userManage: Record<string, any>;
} = {
	userManage: {},
};

const manageUserlice = createSlice({
	name: "manageUser",
	initialState,
	reducers: {
		setUserManage: (state, action: PayloadAction<{}>) => {
			state.userManage = action.payload;
		},
	},
});

export const { setUserManage } = manageUserlice.actions;
export default manageUserlice.reducer;
